import { render } from "./stock-in.vue?vue&type=template&id=ceaa4568&scoped=true"
import script from "./stock-in.vue?vue&type=script&lang=js"
export * from "./stock-in.vue?vue&type=script&lang=js"

import "./stock-in.vue?vue&type=style&index=0&id=ceaa4568&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceaa4568"]])

export default __exports__